export type RccTheme = {
  page: string;
  surface: string;
  surfaceMuted: string;
  surfaceHover: string;
  border: string;
  borderSubtle: string;
  borderActive: string;
  chip: string;
  chipBorder: string;
  chipHover: string;
  popover: string;
  divide: string;
};

/** Slate Classic — cool gray canvas, white cards */
export const DEFAULT_RCC_THEME: RccTheme = {
  page: 'bg-slate-100',
  surface: 'bg-white',
  surfaceMuted: 'bg-slate-50',
  surfaceHover: 'hover:bg-slate-50',
  border: 'border-slate-200',
  borderSubtle: 'border-slate-100',
  borderActive: 'border-slate-300',
  chip: 'bg-slate-100',
  chipBorder: 'border-slate-200',
  chipHover: 'hover:bg-slate-200',
  popover: 'bg-white',
  divide: 'divide-slate-100',
};
